import { FC } from "react";
import { Content } from "@prismicio/client";
import { SliceComponentProps } from "@prismicio/react";

/**
 * Props for `SpeedChecker`.
 */
export type SpeedCheckerProps = SliceComponentProps<Content.SpeedCheckerSlice>;

/**
 * Component for "SpeedChecker" Slices.
 */
const SpeedChecker: FC<SpeedCheckerProps> = ({ slice }) => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
    >
      <div className="w-full h-full my-16 max-w-[1280px] mx-auto">
            <iframe src={slice.primary.ookla_code as string} className="w-full h-[60dvh] border-none"></iframe>
          </div>
    </section>
  );
};

export default SpeedChecker;
